import { ApiDetails } from "./config.interfaces";

export const api: ApiDetails = {
  base: "https://mind.findingyou.co/api/",
  key: "eKabd7G;bd",
  suffixSplitChars: ["%", ".", ","],
};
